import { Drawer, Layout } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import clsx from 'clsx';
import HeaderComponent from 'components/Common/Header/Header';
import Sidebar from 'components/Common/Sidebar/Sidebar';
import InverterFeature from 'features/Inverter';
import { authActions } from 'features/Login/authSlice';
import PlantFeature from 'features/Plant';
import UserFeature from 'features/User';
import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import style from './Home.module.scss';
import { homeActions, selectUserInfo } from './homeSlice';
export default function Home() {
  const { Header, Sider, Content } = Layout;
  const [visible, setVisible] = useState<boolean>(false);
  const userInfo = useAppSelector(selectUserInfo);

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(homeActions.fetchUserInfo());
  }, [dispatch]);

  useEffect(() => {
    if (userInfo && userInfo.authority !== 'TENANT_ADMIN') {
      dispatch(authActions.setIsDisable(true));
    }
  }, [userInfo]);

  const onClose = () => {
    setVisible(false);
  };

  return (
    <Layout className={style.root}>
      <Sider
        className={clsx(style.sidebar, {
          [style.hiddenSidebar]: visible === true,
        })}
        width={300}
      >
        <Sidebar />
      </Sider>
      <Drawer
        className={style.showDrawerSidebar}
        placement={'left'}
        closable={false}
        onClose={onClose}
        visible={visible}
        key={'left'}
        width={350}
      >
        <Sidebar />
      </Drawer>
      <Layout>
        <Header className={style.header}>
          <HeaderComponent visible={visible} setVisible={setVisible} />
        </Header>
        <Content>
          <Switch>
            <Route path="/user">
              <UserFeature />
            </Route>
            <Route path="/plant">
              <PlantFeature />
            </Route>
            <Route path="/inverter">
              <InverterFeature />
            </Route>
          </Switch>
        </Content>
      </Layout>
    </Layout>
  );
}
